export const InfoCard = ({ classBG, name, subName, amount, classTitle, classAmount, classDiv, subAmount, classSubAmount }) => {
  return (
    <>
      <div className={`tw-w-full tw-rounded-md tw-py-3 tw-px-5 tw-h-[90px] ${classBG}`}>
        <div className={`tw-flex tw-gap-1 tw-mt-1 ${classDiv}`}>
          <div>
            <p className={`tw-text-[14px] !tw-p-0 !tw-m-0 tw-font-normal ${classTitle}`}>{name}</p>
          </div>
          <div className={`${classDiv}`}>
            <p className={`tw-text-[14px] !tw-p-0 !tw-m-0 tw-font-normal ${classTitle}`}>{subName}</p>
          </div>
        </div>
        <div className="tw-mt-3 tw-flex tw-justify-between">
          <p className={`tw-text-lg tw-font-medium ${classAmount}`}>{amount}</p>
          {
            subAmount && 
              <p className={`tw-text-sm tw-font-bold tw-text-gray-500 tw-mt-1 ${classSubAmount}`}>{subAmount}</p>
            
          }
        </div>

      </div>

    </>
  )
}